import React from 'react';
import { Box } from '@mui/material';
import { useShowContext } from 'framework/show';
import { useAuthorization } from 'framework/authorization';
import { UPDATE_EMPLOYEE_REQUISITES_INFORMATION } from 'domain/shared/employee';
import { ShowSection } from 'framework/ui/layout';
import { useFormShowContext, TextInput } from 'framework/form';
import FormActionButtons from '../../../shared/button/showEdit/FormActionButtons';
import EditFormShowButton from '../../../shared/button/showEdit/EditFormShowButton';
import { Requisites } from './types';
import { AttachmentsListField } from 'domain/shared/artifact/field';
import { DocumentScanUploaderInput } from 'domain/shared/employee';
import DescriptionIcon from '@mui/icons-material/Description';
import SectionField from '../../accounts/shared/SectionField';

const RequisitesContent: React.FC = () => {
  const { data: employee } = useShowContext();
  const { isGranted } = useAuthorization();
  const { isEditMode } = useFormShowContext();

  if (!isGranted(UPDATE_EMPLOYEE_REQUISITES_INFORMATION)) {
    return null;
  }

  const requisites: Requisites = employee?.getValueBySource('extendedInformation.requisitesInformation');

  const getEditActions = () => {
    return isEditMode ? (
      <FormActionButtons />
    ) : (
      <EditFormShowButton requiredPermission={UPDATE_EMPLOYEE_REQUISITES_INFORMATION} />
    );
  };

  if (isEditMode) {
    return (
      <ShowSection icon={<DescriptionIcon />} actions={getEditActions()} disableDefaultPadding>
        <Box sx={{ pl: 1 }}>
          <TextInput source="extendedInformation.requisitesInformation.requisites" label="Requisites" />
          <DocumentScanUploaderInput
            source="extendedInformation.requisitesInformation.scansIds"
            label="Document scans"
          />
        </Box>
      </ShowSection>
    );
  }

  return (
    <ShowSection icon={<DescriptionIcon />} actions={getEditActions()} disableDefaultPadding>
      <Box sx={{ pl: 1 }}>
        <SectionField label="Requisites">{requisites?.requisites}</SectionField>
        <AttachmentsListField value={requisites?.scansIds} />
      </Box>
    </ShowSection>
  );
};

export default RequisitesContent;
